
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.288 30.933h-3.65c-.465 0-.842.24-.842.534s.377.532.842.532h3.65c.463 0 .841-.238.841-.532s-.378-.534-.841-.534z"}}),_c('path',{attrs:{"d":"M25.609 30.933H1.051c-.583 0-1.056.24-1.056.534s.473.532 1.056.532h24.558c.58 0 1.053-.238 1.053-.532s-.473-.534-1.053-.534z"}}),_c('path',{attrs:{"d":"M24.529 6.94c-.004 3.83-2.872 6.931-6.408 6.926-3.535-.003-6.397-3.11-6.392-6.939S14.602-.004 18.137 0c3.536.004 6.397 3.111 6.392 6.94z"}}),_c('path',{attrs:{"d":"M22.267 14.933c-.199 2.466-7.008 2.466-7.207 0l-7.509 2.725s-1.155 1.294-1.155 2.314.022 3.746.022 3.746 5.26 4.137 12.089 4.012c6.831.124 12.401-4.012 12.401-4.012s.022-2.726.022-3.746c0-1.021-1.155-2.314-1.155-2.314l-7.508-2.725z"}})])
          )
        }
      }
    